var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningBlueCircule(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00033 16.0832C12.9123 16.0832 16.0837 12.9119 16.0837 8.99984C16.0837 5.08782 12.9123 1.9165 9.00033 1.9165C5.08831 1.9165 1.91699 5.08782 1.91699 8.99984C1.91699 12.9119 5.08831 16.0832 9.00033 16.0832ZM9.00033 17.3332C13.6027 17.3332 17.3337 13.6022 17.3337 8.99984C17.3337 4.39746 13.6027 0.666504 9.00033 0.666504C4.39795 0.666504 0.666992 4.39746 0.666992 8.99984C0.666992 13.6022 4.39795 17.3332 9.00033 17.3332Z",
    fill: "#1570EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28429 6.70817C8.28429 7.12239 8.61908 7.45817 9.03206 7.45817H9.03653C9.44951 7.45817 9.78429 7.12239 9.78429 6.70817C9.78429 6.29396 9.44951 5.95817 9.03653 5.95817H9.03206C8.61908 5.95817 8.28429 6.29396 8.28429 6.70817Z",
    fill: "#1570EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65929 8.91651C9.65929 8.57133 9.37947 8.29151 9.03429 8.29151C8.68911 8.29151 8.40929 8.57133 8.40929 8.91651V11.4165C8.40929 11.7617 8.68911 12.0415 9.03429 12.0415C9.37947 12.0415 9.65929 11.7617 9.65929 11.4165V8.91651Z",
    fill: "#1570EF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningBlueCircule);
export default __webpack_public_path__ + "static/media/warning-blue-circule.47c267effcf5ec6cc1f5828ff455b841.svg";
export { ForwardRef as ReactComponent };